<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Ny Ansatt</h4>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormSubmittable">
        <a href="javascript:;" @click="onBrukerCancel()" class="button primary transparent">Lukk</a>
        <a href="javascript:;" @click="onSaveButtonClick()" class="button primary">Lagre endringer</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormProcessing">
        <a href="javascript:;" class="button primary transparent">Lukk</a>
        <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormLoading">
        <a href="javascript:;" @click="onBrukerCancel()" class="button primary transparent">Lukk</a>
        <a href="javascript:;" class="button primary" disabled>Lagre<span class="show-for-medium"> endringer</span></a>
      </div>
    </div>

    <BrukerCardForm v-on:bruker_form_saved="onBrukerSaved"/>
  </div>
</template>

<script>
import BrukerCardForm from './BrukerCardForm'
import bus from '@/plugins/event-bus'

export default {
  name: 'BrukerCardAdd',
  components: {
    BrukerCardForm
  },
  methods: {
    onBrukerSaved: function (data) {
      this.$helpers.showSuccessAlert('Bruker er lagret')
      this.$router.push({ name: 'BrukerCard', params: {bruker_id: data.Brukerid} })
    },
    onBrukerCancel: function () {
      this.$router.go(-1)
    },
    onSaveButtonClick: function () {
      bus.$emit('bruker-form-submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/BrukerCardAdd.vue